import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "Jay Kular & Associates";
const META = {
  "/": ["SEBI Compliance Consultant in Rajkot | Jay Kular & Associates", "Practising Company Secretaries offering compliance, audit and regulatory advisory to SEBI-regulated entities — Stock Brokers, DPs, RAs, IAs, PMS and AIFs."],
  "/about": ["About Jay Kular & Associates | Practising Company Secretaries", "Founded by CS Jay Kular with 10+ years in SEBI compliance — a proprietorship firm of Practising Company Secretaries serving capital-market intermediaries."],
  "/services": ["SEBI Compliance Services | Brokers, DPs, RAs, IAs, PMS & AIFs", "Registration support, internal audits, inspection assistance and ongoing compliance across six SEBI-regulated verticals."],
  "/blogs": ["Insights on SEBI Compliance | Jay Kular & Associates", "Practical articles on SEBI circulars, audits, inspections and compliance practice for market intermediaries."],
  "/clients": ["Clients & Reviews | Jay Kular & Associates", "The SEBI-regulated entities we support, and reviews from clients on our compliance and audit services."],
  "/contact": ["Contact | SEBI Compliance Consultant, Rajkot", "Talk to Jay Kular & Associates — 104, Sanjay Complex, Rajput Para Main Road, Rajkot 360001. Phone +91 8460042325."],
  "/admin/login": ["Admin | Jay Kular & Associates", "Firm admin desk."],
  "/admin": ["Admin | Jay Kular & Associates", "Firm admin desk."],
};

export const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const key = Object.keys(META).find((k) => (k === "/" ? pathname === "/" : pathname.startsWith(k)));
    const [title, desc] = key && pathname.startsWith("/services/") === false ? META[key] : pathname.startsWith("/services/")
      ? ["SEBI Compliance for Market Intermediaries | Jay Kular & Associates", "Compliance, audit and documentation services for a specific SEBI-regulated vertical."]
      : ["Insights | Jay Kular & Associates", "A practical article on SEBI compliance, audits and regulatory practice for market intermediaries."];
    document.title = title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) { tag = document.createElement("meta"); tag.setAttribute("name", "description"); document.head.appendChild(tag); }
    tag.setAttribute("content", desc);
  }, [pathname]);

  return null;
};
